// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1axT_","actions":"GroupTable_actions__THZ85","deleteModalFooter":"GroupTable_deleteModalFooter__1m0h-"};